import { ReactElement } from "react";
import { BlockTitle } from "@blocks/Blocks";
import { ComponentPropsWithTitle } from "@routes/Keyword/utils/types";
import { cn } from "@util/helpers";

import PodcastSlider from "./PodcastSlider";

/**
 * Podcasts articles displayed on the PODCASTS section
 * https://www.figma.com/design/QCEPjsj7Sdm5KqnY3ta5tq/TEMPLATES--WEB---APP-?node-id=1-12583&m=dev
 */
const Podcasts = ({ props, title }: ComponentPropsWithTitle): ReactElement => {
  if (props.length === 0) return <></>;

  return (
    <div
      data-testid="podcast-component"
      className="border-top border-gray-850 pt-2"
    >
      <BlockTitle
        text={title.toUpperCase()}
        rootClassName={cn("md:mb-4 text-lg md:text-3xl", {
          "w-4/5": props.length > 2,
        })}
      />

      <PodcastSlider cardProps={props} />
    </div>
  );
};

export default Podcasts;
